module.exports = __webpack_public_path__ + "static/media/thumbs_up_icon.78f1f75c.svg";